module.exports = __webpack_public_path__ + "media/dashboard/assets/images/sidebar/clock-9f5ea6775fe9872d0eebf8244f1d6884.svg";